import { useTranslation } from 'react-i18next';

export const useVideoPlaylistNavigationItem = () => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation('navigation');

  return {
    id: 'video-playlists',
    icon: 'Playlist' as const,
    path: `/${locale}/video-playlists`,
    label: t('primary.playlists'),
  };
};
